import React from 'react';
import TaxBillDetail from '../../components/paymentmng/TaxBillDetail';

const TaxBillDetailContainer = ({ taxbill, roInfo }) => {
  return <TaxBillDetail taxbill={taxbill} roInfo={roInfo} />
};

export default TaxBillDetailContainer;
